import { ProgramDescriptionAccordion } from '@components/buzzkuri/shared/uiParts/accordion/ProgramDescription'
import { SummaryProgram } from '@type/buzzkuri/program-detail'
import React from 'react'
import { SummaryProgramHeading } from './Heading'
import { SummaryProgramLecturerProfile } from './LecturerProfile'
import { SummaryProgramPreparations } from './Preparations'
import { SummaryProgramVenue } from './Venue'

type Props = {
  summaryProgram: SummaryProgram
  capacity: number
  requiredTime: number
}

export const SummaryProgramSection = ({
  summaryProgram,
  requiredTime,
  capacity,
}: Props): JSX.Element => {
  const {
    venueType,
    venueDetail,
    lecturerProfile,
    preparations,
    preparationStuffs,
  } = summaryProgram

  return (
    <div className="w-[87.2vw] lg:w-[62.6vw]">
      <ProgramDescriptionAccordion title="概要">
        <div className="px-[6.1vw] pt-[11.3vw] lg:pt-[3.4vw] lg:pr-[5vw] pb-[8vw] lg:pb-[4.5vw] lg:pl-[2.9vw] bg-[#F7F6F5]">
          <div className="flex flex-col">
            <SummaryProgramVenue
              venueType={venueType}
              venueDetail={venueDetail}
            />
            <SummaryProgramLecturerProfile {...{ lecturerProfile }} />
            <SummaryProgramPreparations
              {...{ preparations, preparationStuffs }}
            />
            <div className="flex flex-col mt-[5.8vw] lg:mt-[3.1vw]">
              <SummaryProgramHeading heading="所要時間" />
              <div className="mt-[5.8vw] lg:mt-[2.2vw]">
                <div className="text-[4.3vw] lg:text-[1.3vw] text-[#333333]">
                  {requiredTime}分
                </div>
              </div>
            </div>
            <div className="flex flex-col mt-[5.8vw] lg:mt-[3.1vw]">
              <SummaryProgramHeading heading="参加人数目安" />
              <div className="mt-[5.8vw] lg:mt-[2.2vw]">
                <div className="text-[4.3vw] lg:text-[1.3vw] text-[#333333]">
                  {capacity}名
                </div>
              </div>
            </div>
          </div>
        </div>
      </ProgramDescriptionAccordion>
    </div>
  )
}
